import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AuthPage from "@/pages/AuthPage";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import TrainersPage from "@/pages/TrainersPage";
import PokedexPage from "@/pages/PokedexPage";
import PCPage from "@/pages/PCPage";
import InventoryPage from "@/pages/InventoryPage";
import ShopPage from "@/pages/ShopPage";
import CollegialesPage from "@/pages/CollegialesPage";
import JournalPage from "@/pages/JournalPage";
import TravelJournalPage from "@/pages/TravelJournalPage";
import AdminRoutesPage from "@/pages/AdminRoutesPage";
import AdminTuningPage from "@/pages/AdminTuningPage";
import GradePage from "@/pages/GradePage";
import CartePage from "@/pages/CartePage";
import IntroCinematic from "@/components/IntroCinematic";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading">
        <div className="font-mono text-xs uppercase tracking-widest text-[#4A4A4A]">Chargement du journal...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  // Show the intro cinematic on first login for this account.
  if (user.intro_seen === false) return <IntroCinematic/>;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#FCF9F2",
                color: "#1A1A1A",
                border: "1px solid #2B2B2B",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 12,
              },
            }}
          />
          <Routes>
            <Route path="/auth" element={<PublicOnly><AuthPage/></PublicOnly>}/>
            <Route element={<Protected><Layout/></Protected>}>
              <Route index element={<Dashboard/>}/>
              <Route path="/dresseurs" element={<TrainersPage/>}/>
              <Route path="/pokedex" element={<PokedexPage/>}/>
              <Route path="/pc" element={<PCPage/>}/>
              <Route path="/inventaire" element={<InventoryPage/>}/>
              <Route path="/boutique" element={<ShopPage/>}/>
              <Route path="/collegiales" element={<CollegialesPage/>}/>
              <Route path="/journal" element={<JournalPage/>}/>
              <Route path="/carnet" element={<TravelJournalPage/>}/>
              <Route path="/admin/routes" element={<AdminRoutesPage/>}/>
              <Route path="/admin/tuning" element={<AdminTuningPage/>}/>
              <Route path="/grade" element={<GradePage/>}/>
              <Route path="/carte" element={<CartePage/>}/>
            </Route>
            <Route path="*" element={<Navigate to="/" replace/>}/>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
